import React from 'react'
import { Outlet } from 'react-router'
import Header from '../header/header'
import SideBar from '../sidebar/sideBar'
import Calc from '../components/Calc'

interface Props { }

function DashboardLayout(props: Props) {
    const { } = props

    return (
       <>
            <Header />

            <div className="flex bg-[#F7F7FB] h-[100vh] w-full overflow-x-hidden">
                <SideBar />

                <main className=" w-[100%] min-w-0">
                    <Outlet />
                    <div className="fixed bottom-6 right-6 z-50">
                        {/* <Calc /> */}
                    </div>
                </main>
            </div>
        </>
    )
}

export default DashboardLayout
